<template>
  <div>
    <company-search-box
      :info-text="i18n.t('/Company/CompanyZoekenModal/NationaalZoekenInfo')"
      @on-search="onSearch"
    />
    <alert v-if="errorText" :text="errorText" />
    <p v-html="i18n.t('/Company/CompanyZoekenModal/NationaalZoekenKvkInfo')"></p>
    <loader v-if="isLoading" type="alert" />
  </div>
</template>

<script>
import Alert from '@/components/generic/presentational/atoms/alert/Alert.vue'
import CompanySearchBox from '@/components/generic/presentational/molecules/companySearch/CompanySearchBox.vue'
import StoreConnector from '@/helpers/StoreConnector'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import Companies from '@/api/server/Companies'
import CustomerSearchHelper from '@/helpers/CustomerSearchHelper'

export default {
  components: {
    Loader,
    CompanySearchBox,
    Alert,
  },
  emits: ['hasSearchedNationalCompanies'],
  data() {
    return {
      isLoading: false,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      errorText: '',
    }
  },
  methods: {
    async onSearch(query) {
      this.isLoading = true
      this.errorText = ''
      let searchParams = this.getSearchNationalParams(query)

      try {
        const companies = await Companies.searchNationalCompanies(searchParams)
        StoreConnector.dispatch('companies/setSearchResults', companies)
      } catch {
        this.errorText = this.i18n.t('/Company/CompanyZoekenModal/NationaalZoekenError')
      } finally {
        this.$emit('hasSearchedNationalCompanies')
        this.isLoading = false
      }
    },
    getSearchNationalParams(query) {
      let searchParams = null

      const poIdOrKVKNumber = CustomerSearchHelper.filterPoIdOrKvkNumber(query)
      const kvkLocationNumber = CustomerSearchHelper.filterKvkLocationNumber(query)
      const zipcode = CustomerSearchHelper.filterZipcodeHouseNumber(query)
      const phoneNumber = CustomerSearchHelper.filterPhoneNumber(query)

      if (kvkLocationNumber) {
        searchParams = {
          chamberOfCommerceEstablishment: kvkLocationNumber,
        }
      } else if (zipcode) {
        searchParams = zipcode
      } else if (phoneNumber) {
        searchParams = {
          phone: phoneNumber,
        }
      } else if (poIdOrKVKNumber) {
        searchParams = {
          poIdOrCoC: poIdOrKVKNumber,
        }
      }

      return searchParams
    },
  },
}
</script>

<style></style>
